export default __webpack_public_path__ + "static/media/flag-US.45db8c0f.svg";